export type SlugsProps = {
  primaryBlock: {
    OUR_VALUES: string;
    WHY_WORK: string;
    OUR_IMMERSIVE_EXPERIENCE: string;
    WHY_PROPELIUS_TECHNOLOGIES: string;
    COMPANY_PROJECT_AGILE_PROCESS: string;
    MVP_BONUSE: string;
    MVP_INCLUDES: string;
    WHY_TECH_FOUNDERS: string;
    HIRING_DEVELOPERS: string;
    LAUNCH_PLAN: string;
    WHY_TEAM_STAY_WITH_US: string;
  };
  secondaryBlock: {
    DO_WHAT_YOU_LOVE: string;
    WHAT_YOUR_NEXT_DESTINATION: string;
    TECHNOLOGY_AGNOSTIC: string;
    OUR_FORTUNE_COMPANY: string;
    JOIN_OUR_COMPANY: string;
    DEVELOPER_SPEAK_YOUR_STACK: string;
    TRUSTED_BY_STARTUPS: string;
    SPEED_OR_FREE: string;
    DEADLINE_THAT_CANT_SLIP: string;
  };
  page: {
    ABOUT_US: string;
    HOME: string;
    PAGE_PORTFOLIO: string;
    JOIN_US: string;
    JOB_POST: string;
    CONTACT_PROPELIUS_TECHNOLOGIES: string;
    MVP: string;
    AI_AUTOMATION: string;
    STAFF_AUGMENTATION: string;
    OFFER_PAGE: string;
    PRIVACY_POLICY: string;
    BLOG_PAGE: string;
  };
  highlight: {
    WE_GOT_YOU_COVERed: string;
    WHO_WE_ARE: string;
    DRIVEN_BY_VALUES: string;
  };
  exclusive: {
    EXCLUSIVE: string;
    FLEXIBLE_HIRING_MODELS: string;
    WORDPRESS_IS_SLOW: string;
    SWITCH_TO_ZERO_MENTENANCE_WEBSITE: string;
    SPEED_EQUALS_SALES: string;
  };
  ImpactShowCase: {
    BUILT_PRODUCT_THAT_POWER: string;
  };
  serviceOption: {
    BUILT_TO_FIT_YOUR_JOURNY: string;
  };
};

const Slugs: SlugsProps = {
  primaryBlock: {
    OUR_VALUES: "primary-block-our-values",
    WHY_WORK: "primary-block-why-work-with-us",
    OUR_IMMERSIVE_EXPERIENCE: "primary-block-company-experience",
    WHY_PROPELIUS_TECHNOLOGIES: "why-propelius-technology",
    COMPANY_PROJECT_AGILE_PROCESS: "primary-block-company-thinking",
    MVP_BONUSE: "primary-block-mvp-bonuse",
    MVP_INCLUDES: "primary-block-mvp-includes",
    WHY_TECH_FOUNDERS: "primary-block-why-tech-founders",
    HIRING_DEVELOPERS: "primary-block-hiring-developers",
    LAUNCH_PLAN: "primary-block-launch-plan",
    WHY_TEAM_STAY_WITH_US: "primary-block-why-team-stay-with-us",
  },

  secondaryBlock: {
    DO_WHAT_YOU_LOVE: "secondary-block-do-what-you-love-block",
    WHAT_YOUR_NEXT_DESTINATION: "secondary-block-what-is-your-next-destination",
    TECHNOLOGY_AGNOSTIC: "secondary-block-company-technologies",
    JOIN_OUR_COMPANY: "secondary-block-join-our-company",
    OUR_FORTUNE_COMPANY: "secondary-block-our-fortune-company",
    DEVELOPER_SPEAK_YOUR_STACK: "secondary-block-developer-speak-your-stack",
    TRUSTED_BY_STARTUPS: "secondary-block-trusted-by-startups",
    SPEED_OR_FREE: "secondary-block-speed-or-free",
    DEADLINE_THAT_CANT_SLIP: "secondary-block-have-deadline-that-cant-slip",
  },

  page: {
    ABOUT_US: "page-about-us",
    HOME: "page-home",
    PAGE_PORTFOLIO: "page-portfolio",
    JOIN_US: "page-join-us",
    JOB_POST: "job-post",
    CONTACT_PROPELIUS_TECHNOLOGIES: "contact-propelius-technologies",
    MVP: "90-days-mvp",
    AI_AUTOMATION: "ai-automation-page",
    STAFF_AUGMENTATION: "staff-augmentation-page",
    OFFER_PAGE: "build-a-website-for-my-business",
    PRIVACY_POLICY: "privacy-policy",
    BLOG_PAGE: "blogs",
  },

  highlight: {
    WE_GOT_YOU_COVERed: "we-got-you-covered",
    WHO_WE_ARE: "who-we-are",
    DRIVEN_BY_VALUES: "driven-by-values",
  },

  exclusive: {
    EXCLUSIVE: "exclusive",
    FLEXIBLE_HIRING_MODELS: "flexible-hiring-models",
    WORDPRESS_IS_SLOW: "wordpress-is-slow",
    SWITCH_TO_ZERO_MENTENANCE_WEBSITE: "switch-to-zero-maintenance-website",
    SPEED_EQUALS_SALES: "speed-equals-sales",
  },
  ImpactShowCase: {
    BUILT_PRODUCT_THAT_POWER:
      "impact-showcase-built-product-that-power-real-world",
  },
  serviceOption: {
    BUILT_TO_FIT_YOUR_JOURNY: "service-option-buit-to-fit-your-journey",
  },
};

export default Slugs;
